import { useDeviceType } from '@cian/ui-kit';

import { useApplicationContext } from '../utils/applicationContext';

export const useMobileBottomNavigation = () => {
  const { config } = useApplicationContext();

  const isMobileBottomNavigationEnabled = config.get<boolean>('mobileBottomNavigation.Enabled') ?? false;

  const deviceType = useDeviceType();

  return isMobileBottomNavigationEnabled && deviceType !== 'desktop';
};
